import { CommonModule } from '@angular/common'
import {
  Component,
  computed,
  input,
  output,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import approximateNumber from 'approximate-number'

const approximate = (value: number) => approximateNumber(value, { min10k: true })

@Component({
  selector: 'app-table-pagination',
  imports: [MatIcon, CommonModule, FormsModule],
  template: `
      <button
              (click)="pageNumberChange.emit(1)"
              [disabled]="pageNumber() === 1"
              class="page-arrow"
      >
          <mat-icon svgIcon="first_page"/>
      </button>
      @for (quickPage of quickPages(); track $index) {
          <button
                  (click)="pageNumberChange.emit(quickPage)"
                  class="quick-page"
                  [class.current-page]="quickPage === pageNumber()"
                  [disabled]="quickPage === pageNumber()"
          >
              {{ quickPage }}
          </button>
      }
      <button
              (click)="pageNumberChange.emit(maxPageNumber())"
              [disabled]="pageNumber() === maxPageNumber()"
              class="page-arrow"
      >
          <mat-icon svgIcon="last_page"/>
      </button>
      <hr/>
      <span>{{ statusMessage() }}</span>
  `,
  styles: `
  :host {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;

    button {
        height: 1.5rem;
        min-width: 1.5rem;
        border: none;
        background: whitesmoke;
        border-radius: 0.25rem;
        color: black;

        &:hover:not(:disabled) {
            background: lightgray;
        }

        &.page-arrow {
            padding: 0;
            &:disabled {
              opacity: 0.5;
            }
        }
        
        &.quick-page {
            &.current-page {
                background: var(--active-blue);
                color: white;
            }
        }
    }

    hr {
        transform:rotate(90deg);
        width: 1.5rem;
        margin: 0;
        opacity: 1;
    }

    select {
        height: 1.5rem;
        border-radius: 0.25rem;
    }
  }`,
})
export class TablePaginationComponent {
  pageNumber = input.required<number>()
  pageSize = input.required<number>()
  totalResults = input.required<number>()
  pageNumberChange = output<number>()
  // not used for now
  pageSizeChange = output<number>()

  protected maxPageNumber = computed(() =>
    Math.max(Math.ceil(this.totalResults() / this.pageSize()), 1),
  )
  protected quickPages = computed((): readonly number[] =>
    Array(5)
      .fill(Math.max(1, this.pageNumber() - 2))
      .map((n, i) => n + i)
      .filter(n => n <= this.maxPageNumber() && n >= 1),
  )
  protected statusMessage = computed(() => {
    const totalResults = this.totalResults()
    if (totalResults === 0) {
      return ''
    } else if (this.maxPageNumber() === 1) {
      return `${totalResults} total result${totalResults === 1 ? '' : 's'}`
    } else {
      return `Page ${this.pageNumber()} of ${approximate(this.maxPageNumber())} ` +
        `(${approximate(totalResults)} total results)`
    }
  })
}
